import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import FormLabel from '@material-ui/core/FormLabel';
import * as Color from '../../constants/color';

export const StyledCheckbox = withStyles({
    root: {
        color: Color.PRIMARY_MAIN,
        marginLeft: 20,
    },
})(props => <Checkbox color="default" {...props} />);

export const StyledRadioButton = withStyles({
    root: {
        color: Color.PRIMARY_MAIN,
        marginLeft: 20,
    },
})(props => <Radio color="default" {...props} />);

export const StyledFormLabel = withStyles({
    root: {
        color: 'black',
        marginBottom: '8px',
    },
})(props => <FormLabel {...props} />);
